
import * as types from './types';

export default {
  /**
   * Retorna a lista de links.
   * @param {object} state - O estado atual do módulo.
   * @returns {Array}
   */
  [types.GET_LINKS_LIST]: state => state.links,

  /**
   * Retorna o estado de carregamento.
   * @param {object} state - O estado atual do módulo.
   * @returns {boolean}
   */
  [types.GET_IS_LOADING]: state => state.isLoading,

  /**
   * Retorna a mensagem de erro.
   * @param {object} state - O estado atual do módulo.
   * @returns {string|null}
   */
  [types.GET_ERROR]: state => state.error,
};
